import {Icon, Layout, Text} from '@eitje/web_components'
import {FIRM_STATUS_ICON_MAPPING} from '~/components/advanced_table/components/cells/firm_status_icon_mapping'

export const StatusRow = ({item}) => {
	const {value, description, infoIconMessage} = item
	const {color, icon} = FIRM_STATUS_ICON_MAPPING[value]
	return (
		<>
			<Text t={description} infoIconMessage={infoIconMessage} />
			<Layout gap={4}>
				<Icon name={icon} fill={color} size={14} />
				<Text t={`common.status.${value}`} />
			</Layout>
		</>
	)
}
